var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pano-setting-modal",
      attrs: {
        visible: _vm.settingVisible,
        center: "",
        "destroy-on-close": "",
      },
      on: { close: _vm.onClose },
    },
    [
      _c(
        "div",
        { staticClass: "setting_wrapper" },
        [
          _c("div", { staticClass: "video-view-wrapper" }, [
            _c("div", { ref: "view", staticClass: "video_view" }),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "分辨率", "label-position": "left" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.selectedVideoProfile,
                        callback: function ($$v) {
                          _vm.selectedVideoProfile = $$v
                        },
                        expression: "selectedVideoProfile",
                      },
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "Standard" } }, [
                        _vm._v("360P"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "HD720P" } }, [
                        _vm._v("720P"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "摄像头", "label-position": "left" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.camera,
                        callback: function ($$v) {
                          _vm.camera = $$v
                        },
                        expression: "camera",
                      },
                    },
                    _vm._l(_vm.cameras, function (item) {
                      return _c("el-option", {
                        key: item.deviceId,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "麦克风", "label-position": "left" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.mic,
                        callback: function ($$v) {
                          _vm.mic = $$v
                        },
                        expression: "mic",
                      },
                    },
                    _vm._l(_vm.mics, function (item) {
                      return _c("el-option", {
                        key: item.deviceId,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "扬声器", "label-position": "left" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.speaker,
                        callback: function ($$v) {
                          _vm.speaker = $$v
                        },
                        expression: "speaker",
                      },
                    },
                    _vm._l(_vm.speakers, function (item) {
                      return _c("el-option", {
                        key: item.deviceId,
                        attrs: { label: item.label, value: item.deviceId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "时长上限", "label-position": "left" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "245px" },
                    attrs: { value: "90分钟", disabled: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "人数上限", "label-position": "left" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "245px" },
                    attrs: { value: "25人", disabled: "" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showFeedback },
                    },
                    [_vm._v("反馈与报障")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/Setting.vue?vue&type=template&id=c5062c04&
// module id = null
// module chunks = 